import React from 'react';

export const MissIcon = ({ fill = '#000' }: { fill?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="90%" height="90%" fill={fill}>
    <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
  </svg>
);

export const HitIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="90%" height="90%" viewBox="0 0 256 256">
    <g>
      <path
        fill="#F05134"
        d="M120.053,255.883c-75.035,0-89.935-61.697-76.099-95.792c13.836-34.095,37.783-44.377,28.736-68.73
		c0,0,18.093,7.576,19.69,30.306c0,0,31.929-9.199,26.075-41.671c-5.854-32.472,0.533-64.942,25.012-79.555
		c0,0,0.532,43.837,16.496,63.86c15.966,20.024,24.139,47.967,16.689,69.613c0,0,15.772-10.083,18.434-31.729
		C195.088,102.185,277.573,255.883,120.053,255.883z"
      />
      <path
        fill="#F78C23"
        d="M126.601,239.773c-59.258,0-97.805-47.177-50.628-107.584c0,0,9.781,8.629,9.206,27.038
		c0,0,52.354-20.135,49.478-94.927c0,0,33.944,48.903,30.491,98.955c0,0,20.137,2.877,29.342-22.438
		C194.488,140.818,236.486,239.773,126.601,239.773z"
      />
      <path
        fill="#FED937"
        d="M118.323,226.541c-45.493,0-37.068-46.616-14.041-59.535c23.027-12.917,35.385-47.177,35.385-47.177
		S189.091,226.541,118.323,226.541z"
      />
      <path
        fill="#FDF499"
        d="M119.308,219.605c-28.805,0-23.471-29.517-8.89-37.695c14.58-8.18,22.404-29.872,22.404-29.872
		S164.117,219.605,119.308,219.605z"
      />
    </g>
  </svg>
);

export const SunkIcon = () =>
  // prettier-ignore
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="362.476px" height="348.011px" viewBox="-50 -50 412.476 398.011" enableBackground="new 0 0 362.476 348.011">
<path fill="#FFFFFF" d="M113.092,310.162c0,10.911,6.103,19.753,13.63,19.753c4.466,0,8.417-3.126,10.903-7.938
	c2.486,4.812,6.438,7.938,10.904,7.938c4.465,0,8.417-3.126,10.903-7.938c2.485,4.812,6.438,7.938,10.903,7.938
	c4.467,0,8.418-3.126,10.904-7.938c2.486,4.812,6.438,7.938,10.904,7.938s8.417-3.126,10.904-7.938
	c2.484,4.812,6.437,7.938,10.903,7.938c4.465,0,8.416-3.126,10.902-7.938c2.485,4.812,6.438,7.938,10.904,7.938
	c7.527,0,13.63-8.842,13.63-19.753v-7.111v-9.901c4.691,1.404,9.661,2.17,14.813,2.17c28.471,0,51.555-23.081,51.555-51.555
	c0-6.624-1.264-12.947-3.54-18.766c9.843-19.679,15.391-41.881,15.391-65.38c0-80.836-65.529-146.368-146.367-146.368
	c-80.837,0-146.368,65.531-146.368,146.368c0,23.5,5.546,45.702,15.389,65.38c-2.276,5.818-3.536,12.142-3.536,18.766
	c0,28.474,23.08,51.555,51.553,51.555c5.151,0,10.12-0.766,14.815-2.17v9.901V310.162z"/>
<g>
	<circle cx="111.501" cy="187.265" r="39.306"/>
	<circle cx="250.976" cy="187.265" r="39.307"/>
</g>
<g>
	<path d="M177.13,252.243c4.968-10.626,1.819-22.595,1.819-22.595s-11.207,5.258-16.175,15.882
		c-4.97,10.626-5.783,20.743-1.817,22.597C164.922,269.98,172.164,262.869,177.13,252.243z"/>
	<path d="M185.346,252.243c-4.968-10.626-1.815-22.595-1.815-22.595s11.206,5.258,16.174,15.882
		c4.968,10.626,5.783,20.743,1.818,22.597C197.557,269.98,190.315,262.869,185.346,252.243z"/>
</g>
</svg>;
